import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ConfigService } from './../config/config.service';
import { BehaviorSubject, of } from 'rxjs';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { map } from 'rxjs/operators';
import { StorageService } from '../storage/storage.service';
import { SharedService } from '../shared/shared.service';
import { ApiResponse } from '../api-response.interface';
import * as $ from 'jquery';
import { catchError } from 'rxjs/operators';

export interface CmsApiResponse<T> {
  status: string;
  message: string;
  data: T;
}

export interface Page {
  _id?: string;
  order?: number;
  active?: boolean;
  activeDate?: string;
  activeOnDate?: boolean;
  label: string;
  newtab?: boolean;
  private?: boolean;
  publish?: boolean;
  publishDate?: string;
  publishToAllLibs?: boolean;
  publishActiveOnDate?: boolean;
  redirectUrl: string | null;
  routeLink?: string | null;
  linkPage?: boolean;
  widgetPage?: boolean;
  templates?: [any];
  showGuest: boolean;
  showPatron: boolean;
  showStaff: boolean;
  targetLibLid?: string;
  targetLibName?: string;
  targetLibForPublishedPage?: string;
  isGlobal?: boolean;
  globalPublishArr?: [];
  guid?: string;
  totalLidsArr?: [];
  homeDate: string;
  publishToCertainLids: string[];
  sharedWith: string;
}

export interface LinkPage {
  redirectUrl: string | null;
  routeLink: string | null;
  linkPage: boolean;
  widgetPage: boolean;
  templates: [any];
  showGuest: boolean;
  showPatron: boolean;
  showStaff: boolean;
  targetLibLid: string;
  targetLibName: string;
  targetLibForPublishedPage: string;
}

export enum CREATE_NEW_PAGE_TYPE {
  PAGE = 'page',
  LINK = 'link',
  WIDGET = 'widget',
}

export enum CUSTOM_TEMPLATE_TYPE {
  FEATURES_ONE = 'featuresOne',
  FEATURES_TWO = 'featuresTwo',
  FEATURES_THREE = 'featuresThree',
  TEAMS_ONE = 'TeamsOne',
  TEAMS_TWO = 'TeamsTwo',
  TEAMS_THREE = 'TeamsThree',
  DETAILS_ONE = 'detailsOne',
  DETAILS_TWO = 'detailsTwo',
  DETAILS_THREE = 'detailsThree',
  IMAGES_ONE = 'imagesOne',
  IMAGES_TWO = 'imagesTwo',
  IMAGES_THREE = 'imagesThree',
  ABOUT_ONE = 'aboutOne',
  ABOUT_TWO = 'aboutTwo',
  ABOUT_THREE = 'aboutThree',
  CONTACT_ONE = 'contactOne',
  CONTACT_TWO = 'contactTwo',
  CONTACT_THREE = 'contactThree',
  SHOWCASE_WIDGET = 'showcaseWidget',
}

/**
 * Customer and Library ID
 */
export interface LibraryId {
  cid: string;
  lid: string;
}

/**
 * Theme Settings
 */
export interface ThemeSettings extends LibraryId {
  themes: any[];
}
/**
 * Style Settings
 */
export interface StyleSettings extends LibraryId {
  styles: any[];
}
/**
 * Header Settings
 */
export interface HeaderSettings extends LibraryId {
  showLanguages: boolean;
  /** Show Custom Text */
  showTitle: boolean;
  /** Show Logo Only */
  showLogo: boolean;
  /** Show Logo and Custom Text */
  logoAndText: boolean;
  /** Hover Text */
  name: string;
  /** Custom Text */
  customText: string;
  /** Logo Image */
  logoImageURL: string;
  /** Logo Image Link */
  logoRedirectURL: string;
  /** Custom Login Button Text */
  loginButtonText: string;
}
/**
 * Layout Header and Theme Settings
 */
export interface LayoutSettings extends HeaderSettings, StyleSettings, ThemeSettings, LibraryId {}

interface OrderResponse {
  activePages: Page[];
  allPages: Page[];
  inactivePages: Page[];
  libId: string;
}

@Injectable()
export class PredefinedTemplatesService {
  readonly border_colors_bootstrap_btns = {
    primary: '#3394ea',
    secondary: '#3394ea',
    success: '#0fef42',
    danger: '#f10c22',
    warning: '#a58012',
    info: '#06d8f9',
    dark: '#c3c6ca',
    light: '#007bff',
    link: '#007bff',
  };

  label: string;
  active: boolean;
  activeDate: string;
  Private: boolean;
  publish: boolean;
  publishDate: string;
  newtab: boolean;
  routeLink: string;
  templates: any;
  private _libraryBS = new BehaviorSubject<any>(null);

  activePages$ = this._libraryBS.asObservable().pipe(
    map((response) => {
      return response
        ? response[0].pages.filter((page) => page.active).sort((a, b) => a.order - b.order)
        : [];
    }),
  );

  inactivePages$ = this._libraryBS.asObservable().pipe(
    map((response) => {
      return response ? response[0].pages.filter((page: Page) => !page.active) : [];
    }),
  );

  callFooterBS = new BehaviorSubject<boolean>(true);
  customerCarePageBS = new BehaviorSubject<any>(null);
  finalTopicSearchQueriesBS = new BehaviorSubject<any>(null);
  footerBS = new BehaviorSubject<any>(null);
  footerUndefinedBS = new BehaviorSubject<any>(null);
  headerBS = new BehaviorSubject<any>(null);
  homePageBS = new BehaviorSubject<any>(null);
  newPageLabelBS = new BehaviorSubject<any>(null);
  pageByIdBS = new BehaviorSubject<any>(null);
  pageIdEditBS = new BehaviorSubject<any>(null);
  predefined: BehaviorSubject<any> = new BehaviorSubject([]);
  showCaseQueryBS = new BehaviorSubject<any>(null);
  showCaseResultsBS = new BehaviorSubject<any>(null);
  topicSearchQueryBS = new BehaviorSubject<any>(null);

  libraryInfo: any;
  libraryPages: any;
  homePage: any;
  libraryId: any;
  // private _userData:any;
  private _isAddingCustomerCarePage: boolean;

  GLOBAL_TIMEOUT = 100;
  SHOWCASE_TIMEOUT = 4000;

  featuresOne = [
    {
      active: true,
      activeDate: '',
      label: 'Features One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'https://www5.auto-graphics.com/v6assets/assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  featuresTwo = [
    {
      active: true,
      activeDate: '',
      label: 'Features Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  featuresThree = [
    {
      active: true,
      activeDate: '',
      label: 'Features Three',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  TeamsOne = [
    {
      active: true,
      activeDate: '',
      label: 'Teams One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  TeamsTwo = [
    {
      active: true,
      activeDate: '',
      label: 'Teams Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  TeamsThree = [
    {
      active: true,
      activeDate: '',
      label: 'July 4th Happy Holidays',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-421',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-421',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-421',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-421',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  detailsOne = [
    {
      active: true,
      activeDate: '',
      label: 'Details One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  detailsTwo = [
    {
      active: true,
      activeDate: '',
      label: 'Details Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
      ],
    },
  ];

  detailsThree = [
    {
      active: true,
      activeDate: '',
      label: 'Details Three',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  imagesOne = [
    {
      active: true,
      activeDate: '',
      label: 'Images One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-3-1-2-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  imagesTwo = [
    {
      active: true,
      activeDate: '',
      label: 'Images Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-2-1-2',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-2-2-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  imagesThree = [
    {
      active: true,
      activeDate: '',
      label: 'Images Three',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  showCaseWidget = [
    {
      active: false,
      activeDate: '',
      label: 'Showcase Widget',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      linkPage: false,
      widgetPage: true,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
      ],
    },
  ];

  aboutOne = [
    {
      active: true,
      activeDate: '',
      label: 'About One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
      ],
    },
  ];

  aboutTwo = [
    {
      active: true,
      activeDate: '',
      label: 'About Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  aboutThree = [
    {
      active: true,
      activeDate: '',
      label: 'About Three',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  contactOne = [
    {
      active: true,
      activeDate: '',
      label: 'Contact One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
      ],
    },
  ];

  contactTwo = [
    {
      active: true,
      activeDate: '',
      label: 'Contact Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  contactThree = [
    {
      active: true,
      activeDate: '',
      label: 'Contact Three',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-2-1-2',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-2-1-2',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-2-1-2',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-2-1-2',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  featuresOneCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Features One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'https://www5.auto-graphics.com/v6assets/assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  featuresTwoCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Features Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  featuresThreeCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Features Three',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  TeamsOneCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Teams One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  TeamsTwoCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Teams Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  TeamsThreeCopy = [
    {
      active: true,
      activeDate: '',
      label: 'July 4th Happy Holidays',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-421',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-421',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-421',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-421',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  detailsOneCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Details One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  detailsTwoCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Details Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
      ],
    },
  ];

  detailsThreeCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Details Three',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  imagesOneCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Images One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-3-1-2-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  imagesTwoCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Images Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-2-1-2',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-31',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-200 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-2-2-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  imagesThreeCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Images Three',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  aboutOneCopy = [
    {
      active: true,
      activeDate: '',
      label: 'About One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
      ],
    },
  ];

  aboutTwoCopy = [
    {
      active: true,
      activeDate: '',
      label: 'About Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  aboutThreeCopy = [
    {
      active: true,
      activeDate: '',
      label: 'About Three',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  contactOneCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Contact One',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
      ],
    },
  ];

  contactTwoCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Contact Two',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-1',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'two-links height-350',
              color: '',
              targetURL: '',
              background: '',
              imgUrl: 'assets/images/literature_header.jpg',
              backRepeat: 'no-repeat',
              backPos: 'center',
              btnClass: 'btn btn-primary',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-21',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  contactThreeCopy = [
    {
      active: true,
      activeDate: '',
      label: 'Contact Three',
      newtab: false,
      private: false,
      publish: true,
      publishDate: '05/15/2018',
      routeLink: null,
      templates: [
        {
          typeOf: 'col-2-1-2',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-2-1-2',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-2-1-2',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
        {
          typeOf: 'col-2-1-2',
          components: [
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
            {
              typeOf: 'edit',
              rowClass: 'three-links width-100 height-250 pointer',
              color: '',
              background: '',
              imgUrl: '',
              title: "Study for your Driver's License",
              titleBack: '#333',
              paragraph: '',
              btnShow: false,
              btnLabel: 'Check Out Overdrive',
              btnClass: 'btn btn-outline-primary',
              newtab: true,
              flushed: false,
              targetUrl: '',
            },
          ],
        },
      ],
    },
  ];

  constructor(
    private _configService: ConfigService,
    private _http: HttpClient,
    private _sharedService: SharedService,
    private _storageService: StorageService,
    public snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) {}

  private async _getCustomerCarePageJsonAsync(): Promise<any> {
    const customerCareJsonUrl = 'assets/configuration/customer-care.json';
    return this._http.get<any>(customerCareJsonUrl).toPromise();
  }

  underlineActivePage(obj): void {
    if (obj !== null) {
      if (obj.type === 'secondary page') {
        this.addRemoveCurrentClass(obj.index ? obj.index : -1);
      }
      if (obj.type === 'primary page') {
        this.addRemoveCurrentClass(obj.index ? obj.index : -1);
        this.addHomePageCurrentClass();
      }
    }
  }

  addHomePageCurrentClass() {
    if (isPlatformBrowser(this._platformId)) {
      $('.pages1 a').addClass('current-route');
    }
  }

  addRemoveCurrentClass(i = -1) {
    this._removeCurrentClass();
    if (i !== -1) {
      setTimeout(() => {
        this._addCurrentClassPages(i);
      }, 200);
    }
  }

  _removeCurrentClass() {
    if (isPlatformBrowser(this._platformId)) {
      $('a').removeClass('current-route');
    }
  }

  _addCurrentClassPages(i) {
    // all pages except home icon
    if (isPlatformBrowser(this._platformId)) {
      if (this._storageService.getUserData()) {
        $('.pages5')
          .find('#activePages' + i + ' a')
          .addClass('current-route');
      }
    }
  }

  highlightStaffLink() {
    this.addRemoveCurrentClass();
    $('.pages7 a').addClass('current-route');
  }

  highlightHomePageLink() {
    const obj = {
      type: 'primary page',
      index: -1,
    };
    // this.setHeaderPagesLinkObj$(obj);
    this.underlineActivePage(obj);
  }

  // ----------------------------------------------------------------------------------------------------------
  // -------------------------------- Services for home page ----------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------

  //
  // async functions for global page add/delete/update.
  //

  async checkDeletePageStatusAsync(cid, uid) {
    try {
      const url = `${this._configService.expressApi}/service/status/${cid}/${uid}`;
      const response: any = await this._http.get(url).toPromise();
      if (response) {
        if (response.status === '200 OK') {
          return response;
        }
      }
    } catch (error) {
      console.error(`predefinedService.ts:checkDeletePageStatusAsync => ${error.message}`);
    }
    return null;
  }

  async deleteAllGlobalPageASync(body) {
    try {
      const url = `${this._configService.expressApi}/service/remove/bulk`;
      const response: any = await this._http.post(url, body).toPromise();
      if (response) {
        if (response.status === '200 OK') {
          return response;
        }
      }
    } catch (error) {
      console.error(`predefinedService.ts:deleteAllGlobalPageASync => ${error.message}`);
    }
    return null;
  }

  async addGlobalPageToLibraryASync(body) {
    try {
      const url = `${this._configService.expressApi}/service/add/bulk`;
      const response: any = await this._http.post(url, body).toPromise();
      if (response) {
        if (response.status === '200 OK') {
          this.openSnackBar(response.message, 'ok');
        }
      }
    } catch (error) {
      console.error(`predefinedService.ts:addGlobalPageToLibraryASync => ${error.message}`);
    }
    return null;
  }

  async updateExistingPageToLibraryASync(body) {
    try {
      const url = `${this._configService.expressApi}/service/update/bulk`;
      const response: any = await this._http.put(url, body).toPromise();
      if (response) {
        if (response.status === '200 OK') {
          this.openSnackBar(response.message, 'ok');
        }
      }
    } catch (error) {
      console.error(`predefinedService.ts:updateExistingPageToLibraryASync => ${error.message}`);
    }
    return null;
  }

  //
  //
  // GLOBAL PAGE SERVICES START OBSERVABLES FUNCTIONS
  //
  //

  addGlobalPageToLibrary(data): Observable<any> {
    const url = this._configService.expressApi + '/global/new';
    return this.post(url, data);
  }

  updateExistingPageToLibrary(data): Observable<any> {
    const url = this._configService.expressApi + '/global/existing';
    return this.put(url, data);
  }

  deleteGlobalPage4rmLibrary(data): Observable<any> {
    const url = this._configService.expressApi + '/global/delete/remove';
    return this.post(url, data);
  }

  async updateCustomerCarePageAsync(data) {
    try {
      const url = `${this._configService.expressApi}/global/customerCare`;
      const response: any = await this._http.patch(url, data).toPromise();
      if (response) {
        this._sharedService.openSnackBar(response.message);
        return response.data;
      }
    } catch (error) {
      console.error(
        `error in fn updateCustomerCarePageAsync: predefined-template.service.ts  => ${error}`,
      );
    }
    return null;
  }

  deleteAllGlobalPage(data): Observable<any> {
    const url = this._configService.expressApi + '/global/delete/all';
    return this.post(url, data);
  }

  deleteGlobalPagesBatch(data): Observable<any> {
    const url = this._configService.expressApi + '/global/delete/batches';
    return this.post(url, data);
  }

  //
  // GLOBAL PAGE SERVICES END
  //

  // for sets, send cid and lid in the post body

  getLibrary(cid, lid): Observable<any> {
    const url =
      this._configService.expressApi +
      '/library' +
      '/' +
      cid.toLowerCase() +
      '/' +
      lid.toUpperCase();
    return this.get(url).pipe(
      map((response) => {
        if (response) {
          this.setLibraryBS(response.data);
          return response;
        }
      }),
    );
  }

  async getLibraryAsync(cid, lid): Promise<any> {
    try {
      const url = `${
        this._configService.expressApi
      }/library/${cid.toLowerCase()}/${lid.toUpperCase()}`;
      const response: any = await this._http.get(url).toPromise();
      if (response.status === '200 OK') {
        return response.data;
      } else {
        this.openSnackBar(response.message, 'ok');
      }
    } catch (error) {
      console.error(`Error getting library information: ${error.message}`);
    }
    return null;
  }

  async createLibraryAsync(data): Promise<any> {
    try {
      const url = `${this._configService.expressApi}/library`;
      const response = await this._http.put<ApiResponse<any>>(url, data).toPromise();
      this.setLibraryBS(response.data);
      return response;
    } catch (error) {
      this._sharedService.openSnackBar(error.message);
      console.error(`Error creating library: ${error}`);
    }
    return null;
  }

  async addPageToLibraryAsync(data): Promise<any> {
    try {
      const url = `${this._configService.expressApi}/libraries/add`;
      const response = await this._http.post<ApiResponse<any>>(url, data).toPromise();
      this.setLibraryBS(response.data);
      return response;
    } catch (error) {
      this._sharedService.openSnackBar(error.message);
      console.error(`Error adding page to library: ${error}`);
    }
    return null;
  }

  deletePageById(data): Observable<any> {
    const params = new HttpParams();
    const url = this._configService.expressApi + '/page';
    return this._http.put<ApiResponse<any>>(url, data, { params }).pipe(
      map((response) => {
        this.setLibraryBS(response.data);
        return response;
      }),
    );
  }

  setPublish(data): Observable<any> {
    const url = this._configService.expressApi + '/publish';
    return this.post(url, data);
  }

  savePublishPostBody(data): Observable<any> {
    const url = this._configService.expressApi + '/publish/save';
    return this.post(url, data);
  }

  setOrderActivePages(data): Observable<ApiResponse<OrderResponse>> {
    const params = new HttpParams();
    const url = this._configService.expressApi + '/order';
    return this._http.put(url, data, { params }).pipe(
      map((response: ApiResponse<OrderResponse>) => {
        if (response) {
          this._libraryBS.value[0].pages = response.data.allPages;
          this._libraryBS.next(Object.assign({}, this._libraryBS.value));
          return response;
        }
      }),
    );
  }

  async getPageByIdAsync(data): Promise<any> {
    try {
      const url = `${this._configService.expressApi}/page`;
      const response: any = await this._http.post(url, data).toPromise();
      if (response) {
        return response[0];
      }
    } catch (error) {
      console.error(`Error retrieving page by id: ${error.message}`);
    }
    return null;
  }

  getPageByUid(payload): Observable<any> {
    const url = `${this._configService.expressApi}/page/uid`;
    return this._http.post(url, payload).pipe(
      catchError((error: unknown) => {
        return of(error);
      }),
      map((response) => {
        return response[0];
      }),
    );
  }

  deleteTheme(cid, lid, id): Observable<any> {
    const url =
      this._configService.expressApi +
      '/headers/themes' +
      '/' +
      cid.toLowerCase() +
      '/' +
      lid.toUpperCase() +
      '?id=' +
      id;
    return this.delete(url);
  }

  setTheme(data): Observable<CmsApiResponse<LayoutSettings[]>> {
    const url = this._configService.expressApi + '/headers/themes';
    return this._http.post<CmsApiResponse<LayoutSettings[]>>(url, data);
  }

  updateTheme(data): Observable<CmsApiResponse<LayoutSettings>> {
    const url = this._configService.expressApi + '/headers/themes';
    return this._http.put<CmsApiResponse<LayoutSettings>>(url, data);
  }

  /**
   * LayoutSettings that returns header as well as themes and style settings
   * @param cid
   * @param lid
   * @returns
   */
  async getLayoutSettingsAsync(cid: string, lid: string): Promise<LayoutSettings> {
    try {
      const url = `${
        this._configService.expressApi
      }/headers/${cid.toLowerCase()}/${lid.toUpperCase()}`;
      const response: any = await this._http.get(url).toPromise();
      if (response) {
        if (response.status === '200 OK' && response.data !== null && response.data.length > 0) {
          return response.data[0];
        }
      }
    } catch (error) {
      console.error(`predefined-service.ts:getLayoutSettingsAsync => ${error.message}`);
    }
    return {
      cid: cid,
      lid: lid,
      name: null,
      styles: [],
      themes: [],
      showLanguages: false,
      showTitle: false,
      logoAndText: false,
      showLogo: false,
      customText: null,
      logoImageURL: null,
      logoRedirectURL: null,
      loginButtonText: 'Login',
    };
  }

  // Saves the HeaderSettings or StylesSettings.
  // Existing themes and styles will be added to this model in the express api.
  saveHeader(data: HeaderSettings | StyleSettings): Observable<CmsApiResponse<LayoutSettings[]>> {
    const url = this._configService.expressApi + '/headers/add';
    return this._http.post<CmsApiResponse<LayoutSettings[]>>(url, data);
  }

  getFooter(cid, lid): Observable<any> {
    const url =
      this._configService.expressApi +
      '/footers/global' +
      '/' +
      cid.toLowerCase() +
      '/' +
      lid.toUpperCase();
    return this.get(url);
  }

  setFooter(data): Observable<any> {
    const params = new HttpParams();
    const url = this._configService.expressApi + '/footers/add';
    return this._http.post(url, data, { params });
  }

  setFooterGlobal(data): Observable<any> {
    const params = new HttpParams();
    const url = this._configService.expressApi + '/footers/global/add';
    return this._http.post(url, data, { params });
  }

  deleteFooterGlobal(data): Observable<any> {
    const params = new HttpParams();
    const url = this._configService.expressApi + '/footers/global/delete';
    return this._http.post(url, data, { params });
  }

  postFeedBack(data): Observable<any> {
    const params = new HttpParams();
    const url = this._configService.expressApi + '/feedbacks';
    return this._http.post(url, data, { params });
  }

  // --------------------------------------------------------------------------------------------------------------
  // ----------------------------------------- CRUD operations for CMS express api ----------------------------------
  // ----------------------------------------------------------------------------------------------------------------

  postWithPromise(url, data): Promise<any> {
    const params = new HttpParams();
    return new Promise((resolve, reject) => {
      return this._http.post(url, data, { params }).subscribe(
        (res) => {
          resolve(res);
        },
        (err: unknown) => {
          reject(err);
        },
      );
    });
  }

  get(url): Observable<any> {
    return this._http.get(url);
  }

  post(url, data): Observable<any> {
    return this._http.post(url, data);
  }

  put(url, data): Observable<any> {
    return this._http.put(url, data);
  }

  delete(url): Observable<any> {
    return this._http.delete(url);
  }

  // ----------------------------------------------------------------------------------------------------------
  // -------------------------------- getters and setters ----------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------

  setFooterUndefinedBS(value) {
    this.footerUndefinedBS.next(value);
  }

  getFooterUndefinedBS() {
    return this.footerUndefinedBS.asObservable();
  }
  setPageIdEditBS(value) {
    this.pageIdEditBS.next(value);
  }
  getPageIdEditBS() {
    return this.pageIdEditBS.asObservable();
  }

  setNewPageLabelBS(value) {
    this.newPageLabelBS.next(value);
  }

  getNewPageLabelBSValue() {
    return this.newPageLabelBS.getValue();
  }

  setShowCaseResultsBS(value) {
    this.showCaseResultsBS.next(value);
  }

  getShowCaseResultsBS() {
    return this.showCaseResultsBS.asObservable();
  }

  setLibraryBS(value) {
    this._libraryBS.next(value);
  }

  getLibraryBS() {
    return this._libraryBS.asObservable();
  }

  setHomePageBS(value) {
    this.homePageBS.next(value);
  }

  getHomePageBS() {
    return this.homePageBS.asObservable();
  }

  getCustomerCarePageBSValue() {
    return this.customerCarePageBS.getValue();
  }

  setCustomerCarePageBS(value) {
    this.customerCarePageBS.next(value);
  }

  setHeaderBS(value) {
    this.headerBS.next(value);
  }

  getHeaderBS() {
    return this.headerBS.asObservable();
  }

  setFooterBS(value) {
    this.footerBS.next(value);
  }

  getFooterBS() {
    return this.footerBS.asObservable();
  }

  showCustomerCarePage() {
    const customerCarePage = this.getCustomerCarePageBSValue();
    if (customerCarePage) {
      return customerCarePage.showStaff;
    }
    return true;
  }

  //      ---------------------------------------------------------------------------
  //      -------------------------   Chosing a Predefined template -----------------
  //      --------------------------------------------------------------------------

  setNewTemplate(template) {
    let finalTemplate;
    switch (template) {
      case CUSTOM_TEMPLATE_TYPE.FEATURES_ONE:
        finalTemplate = JSON.parse(JSON.stringify(this.featuresOne));
        break;
      case CUSTOM_TEMPLATE_TYPE.FEATURES_TWO:
        finalTemplate = JSON.parse(JSON.stringify(this.featuresTwo));
        break;
      case CUSTOM_TEMPLATE_TYPE.FEATURES_THREE:
        finalTemplate = JSON.parse(JSON.stringify(this.featuresThree));
        break;
      case CUSTOM_TEMPLATE_TYPE.TEAMS_ONE:
        finalTemplate = JSON.parse(JSON.stringify(this.TeamsOne));
        break;
      case CUSTOM_TEMPLATE_TYPE.TEAMS_TWO:
        finalTemplate = JSON.parse(JSON.stringify(this.TeamsTwo));
        break;
      case CUSTOM_TEMPLATE_TYPE.TEAMS_THREE:
        finalTemplate = JSON.parse(JSON.stringify(this.TeamsThree));
        break;
      case CUSTOM_TEMPLATE_TYPE.DETAILS_ONE:
        finalTemplate = JSON.parse(JSON.stringify(this.detailsOne));
        break;
      case CUSTOM_TEMPLATE_TYPE.DETAILS_TWO:
        finalTemplate = JSON.parse(JSON.stringify(this.detailsTwo));
        break;
      case CUSTOM_TEMPLATE_TYPE.DETAILS_THREE:
        finalTemplate = JSON.parse(JSON.stringify(this.detailsThree));
        break;
      case CUSTOM_TEMPLATE_TYPE.IMAGES_ONE:
        finalTemplate = JSON.parse(JSON.stringify(this.imagesOne));
        break;
      case CUSTOM_TEMPLATE_TYPE.IMAGES_TWO:
        finalTemplate = JSON.parse(JSON.stringify(this.imagesTwo));
        break;
      case CUSTOM_TEMPLATE_TYPE.IMAGES_THREE:
        finalTemplate = JSON.parse(JSON.stringify(this.imagesThree));
        break;
      case CUSTOM_TEMPLATE_TYPE.ABOUT_ONE:
        finalTemplate = JSON.parse(JSON.stringify(this.aboutOne));
        break;
      case CUSTOM_TEMPLATE_TYPE.ABOUT_TWO:
        finalTemplate = JSON.parse(JSON.stringify(this.aboutTwo));
        break;
      case CUSTOM_TEMPLATE_TYPE.ABOUT_THREE:
        finalTemplate = JSON.parse(JSON.stringify(this.aboutThree));
        break;
      case CUSTOM_TEMPLATE_TYPE.CONTACT_ONE:
        finalTemplate = JSON.parse(JSON.stringify(this.contactOne));
        break;
      case CUSTOM_TEMPLATE_TYPE.CONTACT_TWO:
        finalTemplate = JSON.parse(JSON.stringify(this.contactTwo));
        break;
      case CUSTOM_TEMPLATE_TYPE.CONTACT_THREE:
        finalTemplate = JSON.parse(JSON.stringify(this.contactThree));
        break;
      case CUSTOM_TEMPLATE_TYPE.SHOWCASE_WIDGET:
        finalTemplate = JSON.parse(JSON.stringify(this.showCaseWidget));
        break;
      default:
        throw new Error(`unable to find template: ${template}`);
    }
    this.predefined.next(finalTemplate);
    this._storageService.setItem('editPage', finalTemplate);
  }

  getNewTemplateValue() {
    return this.predefined.getValue();
  }

  // -------------------------------------------------------------------------------
  // ----------------------------- get library from Express ------------------------
  // -----------------------------------------------------------------------------

  async createLibWithCCPageAndBindLibInfoAsync(cid: string, lid: string): Promise<string> {
    const createNewLibraryPayload = {
      cid: cid,
      lid: lid,
      pages: await this._getCustomerCarePageJsonAsync(),
    };
    const createLibraryResponse = await this.createLibraryAsync(createNewLibraryPayload);
    if (createLibraryResponse?.status === '201 created') {
      console.log(`library created with cid: ${cid} and lid: ${lid} on ${new Date()}`);
      return await this.performLibraryInfoBindingsAsync(createLibraryResponse.data);
    } else if (createLibraryResponse?.status === '200 OK') {
      const message = `library with cid: ${cid} and lid: ${lid} already exists on ${new Date()}`;
      console.log(message);
      return 'failed';
    } else {
      console.error(`unable to create library with customer care page on ${new Date()}`);
      return 'failed';
    }
  }

  async addCustomerCarePageAsync(customerCarePage): Promise<string> {
    this._isAddingCustomerCarePage = true;
    const cid = this._storageService.getCid().toLocaleLowerCase();
    const lid = this._storageService.getLid().toLocaleUpperCase();
    const addPageToLibraryPayload = {
      cid: cid,
      lid: lid,
      libId: this.libraryId,
      pageId: 0,
      page: customerCarePage,
    };
    const response = await this.addPageToLibraryAsync(addPageToLibraryPayload);
    this._isAddingCustomerCarePage = false;
    if (response?.status != '200 OK') {
      if (response?.message == 'customer care page exists already') {
        console.error(
          `customer care page already exists in library with cid: ${cid} and lid:${lid}`,
        );
        return 'failed';
      }
      console.error(
        `failed to add customer care page in existing library with cid: ${cid} and lid:${lid}`,
      );
      return 'failed';
    }
    console.log(`customer care page added in existing library with cid: ${cid} and lid:${lid}`);
    this.libraryInfo = response?.data;
    this.libraryPages = this.libraryInfo[0]?.pages;
    return 'success';
  }

  async getLibAndBindInfoAsync(cid: string, lid: string): Promise<string> {
    if (SharedService.isEmpty(cid) || SharedService.isEmpty(lid)) {
      console.error(
        `error in _libraryInfoBindings in predefined.service.ts: => cid:${cid} and/or lid:${lid} missing`,
      );
      return 'failed';
    }

    cid = cid.toLocaleLowerCase();
    lid = lid.toLocaleUpperCase();

    const libraryResponse = await this.getLibraryAsync(cid, lid);
    if (libraryResponse === null) {
      console.error(
        `error in _libraryInfoBindings in predefined.service.ts: => ${libraryResponse}`,
      );
      return 'failed';
    }
    if (libraryResponse?.length) {
      return await this.performLibraryInfoBindingsAsync(libraryResponse);
    } else if (!(await this._getCustomerCarePageJsonAsync())) {
      console.error('customer care json missing');
      return 'failed';
    }
    return await this.createLibWithCCPageAndBindLibInfoAsync(cid, lid); // 68595 - Need to add new default "Customer Care" automatically with new implementation
  }

  async performLibraryInfoBindingsAsync(data): Promise<string> {
    if (!data?.length) {
      this._setLibraryPagesDefaults();
      return 'failed';
    }

    this.libraryInfo = data;
    this.libraryPages = this.libraryInfo[0].pages;
    this.libraryId = this.libraryInfo[0]._id;
    this.setLibraryBS(this.libraryInfo);
    this._storageService.setItem('libId', this.libraryId);
    this._storageService.setItem('libExists', true);

    const customerCarePage = this.libraryPages.find((x) => x.guid === 'thisIsACustomerCarePage');
    if (!customerCarePage && !this._isAddingCustomerCarePage) {
      // 68595 - Need to add new default "Customer Care" automatically with new implementation
      const status: string = await this.addCustomerCarePageAsync(
        await this._getCustomerCarePageJsonAsync(),
      );
      if (status === 'failed') {
        return status;
      }
    }
    this.setCustomerCarePageBS(customerCarePage);

    for (let i = 0; i < this.libraryPages.length; i += 1) {
      const element = this.libraryPages[i];
      if (element.active && element.order === 1) {
        this.homePage = element;
        this.setHomePageBS(this.homePage);
        break;
      }
    }

    return 'success';
  }

  private _setLibraryPagesDefaults(): void {
    this.setLibraryBS(undefined);
    this.setHomePageBS(undefined);
    this.setCustomerCarePageBS(undefined);
  }

  setDefaultPages(): void {
    this.featuresOne = this.featuresOneCopy.slice(0);
    this.featuresTwo = this.featuresTwoCopy.slice(0);
    this.featuresThree = this.featuresThreeCopy.slice(0);
    this.TeamsOne = this.TeamsOneCopy.slice();
    this.TeamsTwo = this.TeamsTwoCopy.slice();
    this.TeamsThree = this.TeamsThreeCopy.slice();
    this.detailsOne = this.detailsOneCopy.slice();
    this.detailsTwo = this.detailsTwoCopy.slice();
    this.detailsThree = this.detailsThreeCopy.slice();
    this.imagesOne = Object.assign([], this.imagesOneCopy);
    this.imagesTwo = Object.assign([], this.imagesTwoCopy);
    this.imagesThree = Object.assign([], this.imagesThreeCopy);
    this.aboutOne = this.aboutOneCopy.slice(0);
    this.aboutTwo = Object.assign([], this.aboutTwoCopy);
    this.aboutThree = Object.assign([], this.aboutThreeCopy);
    this.contactOne = Object.assign([], this.contactOneCopy);
    this.contactTwo = Object.assign([], this.contactTwoCopy);
    this.contactThree = Object.assign([], this.contactThreeCopy);
  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  getBtnColorForTabFocus508(btnClass): string {
    let color = '';
    if (btnClass.includes('btn-primary') || btnClass.includes('btn-outline-primary')) {
      color = this.border_colors_bootstrap_btns['primary'];
    } else if (btnClass.includes('btn-secondary') || btnClass.includes('btn-outline-secondary')) {
      this.border_colors_bootstrap_btns['secondary'];
    } else if (btnClass.includes('btn-success') || btnClass.includes('btn-outline-success')) {
      color = this.border_colors_bootstrap_btns['success'];
    } else if (btnClass.includes('btn-danger') || btnClass.includes('btn-outline-danger')) {
      color = this.border_colors_bootstrap_btns['danger'];
    } else if (btnClass.includes('btn-warning') || btnClass.includes('btn-outline-warning')) {
      color = this.border_colors_bootstrap_btns['warning'];
    } else if (btnClass.includes('btn-info') || btnClass.includes('btn-outline-info')) {
      color = this.border_colors_bootstrap_btns['info'];
    } else if (btnClass.includes('btn-light') || btnClass.includes('btn-outline-light')) {
      color = this.border_colors_bootstrap_btns['light'];
    } else if (btnClass.includes('btn-dark') || btnClass.includes('btn-outline-dark')) {
      color = this.border_colors_bootstrap_btns['dark'];
    } else if (btnClass.includes('btn-link') || btnClass.includes('btn-outline-link')) {
      color = this.border_colors_bootstrap_btns['link'];
    }
    return color;
  }

  mapToPage(element) {
    return {
      label: element.label,
      _id: element._id,
      order: element.order,
      showGuest: element.showGuest,
      showPatron: element.showPatron,
      showStaff: element.showStaff,
      linkPage: element.linkPage,
      redirectUrl: element.redirectUrl,
      targetLibForPublishedPage: element.targetLibForPublishedPage,
      targetLibName: element.targetLibName,
      targetLibLid: element.targetLibLid,
      isGlobal: element.isGlobal,
      globalPublishArr: element.globalPublishArr || [],
      guid: element.guid || '',
      totalLidsArr: element.totalLidsArr || [],
      widgetPage: element?.widgetPage,
    };
  }
}
